module.exports = __webpack_public_path__ + "static/app-icon.5899ca1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/stronglist/app-icon.png
// module id = 382
// module chunks = 212420072151734